import API from "../utils/api";

export const ACTION_TYPES = {
    LABEL_CREATE: 'LABEL_CREATE',
    LABEL_UPDATE: 'LABEL_UPDATE',
    LABEL_DELETE: 'LABEL_DELETE',
    LABEL_FETCH: 'LABEL_FETCH',
    LABEL_FETCH_ALL: 'LABEL_FETCH_ALL',
    LABEL_PAGINATION: 'LABEL_PAGINATION'
}

export const fetchAll = () => dispatch => {
    API.label().fetchAll()
        .then(res => {
            dispatch({
                type: ACTION_TYPES.LABEL_FETCH_ALL,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const Pagination = (page = 1, limit = 5, name = "") => dispatch => {
    API.label().fetchPagination(page, Math.abs(limit), name)
        .then(res =>{
         
            dispatch({
                type: ACTION_TYPES.LABEL_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const fetchById = (id, onSuccess) => dispatch => {
    API.label().fetchById(id)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.LABEL_FETCH,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const create = (input, onSuccess) => dispatch => {
    API.label().create(input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.LABEL_CREATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const update = (id, input, onSuccess) => dispatch => {

    API.label().update(id, input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.LABEL_UPDATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const Delete = (id, onSuccess) => dispatch => {
    API.label().delete(id)
        .then(res =>{
         
            dispatch({
                type: ACTION_TYPES.LABEL_DELETE,
                payload: res.data.id
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}